import { ALLOWED_CATEGORY_STATUES } from '../../../../constants';
import { CategoryStatus } from '../../../../../../__generated__/queries-web';

export const INITIAL_QUERY_PARAMS = {
  filterStatus: ALLOWED_CATEGORY_STATUES.filter(
    (status) => status.id !== CategoryStatus.Deleted,
  ).map((status) => status.id),
};

export const FILTER_TITLE = 'Filtrer la liste';
export const RESET_FILTER_TITLE = 'Réinitialiser';
